import React, { useState } from 'react';
import { FileTextOutlined, PictureOutlined } from '@ant-design/icons';
import { Divider, Image, Tag, Typography } from 'antd';
import ExpandableHtmlText from "../../../components/ExpandableHtmlText";
import { Fragment } from 'react';

const { Text } = Typography;


const TAG_COLOR_MAP = {
    industry: 'default',
    skill: 'geekblue',
    discipline: 'purple',
    'Gold Partner': 'gold',
    'Certified Partner': 'cyan',
}

const renderBadge = (text, type) => {
    // const colorMap = {
    //     industry: 'default',
    //     skill: 'geekblue',
    //     discipline: 'purple'
    // };
    // const iconMap = {
    //     industry: BankOutlined,
    //     skill: ToolOutlined,
    //     discipline: TeamOutlined
    // };
    //
    // const TagIcon = iconMap[type] || React.Fragment;
    return (
        <Tag
            key={text}
            // icon={<TagIcon />}
            color={TAG_COLOR_MAP[type]}>
            {text}
        </Tag>
    )
};

const getPDFAssets = (project) => {
    return project?.assets?.filter(asset =>
        asset.content_type === "PDF" || asset.content_type === "Document"
    ) || [];
};

const getMediaAssets = (project) => {
    const assets = project?.assets?.filter(asset =>
        (asset.content_type === "Image" || asset.content_type === "Video") && asset.path
    ) || [];

    assets.unshift({ path: project.image_path, caption: project.headline, id: project.id })
    return assets;
};


const ProfileKeyClientRow = ({ project }) => {
    const [visible, setVisible] = useState(false);

    const content = [
        '<div class="ml-3 w-16 h-8 float-right"></div>',
        TB.stripHtml(project.description)?.length > 0 ? project.description : '<i>No Description Provided</i>',
    ];

    return (
        <div className="pt-3 w-full key-client-row">
            <div className="flex flex-row items-end justify-between gap-6">
                <h5 className="text-lg font-bold">{project.headline}</h5>
            </div>

            <div className="flex gap-6 pt-2 items-start">
                <div className="relative w-2/5">

                    <div className="relative">
                        <Image
                            preview={project.image_path ? { visible: false } : false}
                            wrapperClassName="border border-gray-300"
                            src={project.image_path || '/images/talent/project-case-studies-default.jpeg'}
                            className={TB.mapClass("object-cover transition-transform aspect-video", { "hover:scale-105": !!project.image_path })}
                            fallback='/images/talent/project-case-studies-default.jpeg'
                            onClick={() => project.image_path && setVisible(true)}
                        />
                        {getMediaAssets(project)?.length > 1 && (
                            <div
                                className="pointer-events-none absolute bottom-3 right-2 rounded-md px-1.5 py-1.5 flex flex-row gap-1.5 items-end justify-center bg-black bg-opacity-60">
                                <PictureOutlined className="text-white text-base" />
                                <div className="text-xs text-white">
                                    {getMediaAssets(project)?.length}
                                </div>
                            </div>
                        )}
                        {getMediaAssets(project)?.length >= 1 && (
                            <div style={{ display: 'none' }}>
                                <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>
                                    {getMediaAssets(project).map(img => <Image key={img.path} src={img.path} />)}
                                </Image.PreviewGroup>
                            </div>
                        )}
                    </div>
                </div>

                <div className="w-3/5 space-y-4">
                    <div className="flex gap-4 items-center justify-between w-full">

                        <div className="flex justify-between items-center border-b pb-2 w-full">
                            <span className="text-sm text-gray-500">Project Overview {project.year ? `- Year: ${project.year}` : ''}</span>
                        </div>

                        {!!project.brands.length && (
                            <div className="ml-auto flex flex-row flex-wrap gap-1.5 relative w-16">
                                {project.brands.slice(0, 1).map((brand, index) => (
                                    <div key={brand.id + 'project_brands' + index} className="w-16 h-16 flex items-center justify-center absolute top-[-22px] right-0">
                                        <Image
                                            preview={false}
                                            src={brand.icon || ""}
                                            alt={brand.name}
                                            className="max-w-full max-h-full object-contain"
                                            fallback="data:image/png;base64,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"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* <div className="flex justify-between items-center border-b pb-2">
                        <span className="text-sm text-gray-500">Project Overview - Year: {project.year}</span>
                    </div> */}

                    {/* <div className="pt-4">
                        <ExpandableHtmlText
                            content={TB.stripHtml(project.description)?.length > 0 ?
                                project.description : '<i>No Description Provided</i>'
                            }
                            maxHeight={190}
                        />
                    </div> */}

                    <ExpandableHtmlText
                        content={content.join('')}
                        maxHeight={190}
                        additionalContent={
                            !!project.brands.length && (
                                <div>
                                    <Divider className={TB.mapClass("my-2", { "border-transparent": TB.stripHtml(project.description)?.length === 0 })} />
                                    <div className="flex flex-col gap-2">
                                        {project.brands.map((brand) => (
                                            <div key={`p-${project.id}-${brand.id}`} className="flex flex-row items-center gap-2">
                                                <div className="w-8 h-8 flex items-center justify-center">
                                                    <Image
                                                        preview={false}
                                                        src={brand.icon || "data:image/png;base64,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"}
                                                        alt={brand.name}
                                                        title={brand.name + (brand.domain ? (' ' + brand.domain) : '')}
                                                        className="max-w-full max-h-full object-contain"
                                                    />
                                                </div>
                                                <span className="text-xs mb-0 text-[rgba(0, 0, 0, 0.75)]">{brand.name}</span>
                                                <a className="ml-3 flex-grow text-link-info p-0 text-xxs text-ellipsis max-w-64" style={{ marginBottom: '0px!important' }}>{brand.domain}</a>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            )
                        }
                    />

                    <div className="py-3 flex flex-wrap gap-y-2 gap-x-1.5">
                        {project.disciplines?.map((discipline) => renderBadge(discipline.name, 'discipline'))}
                        {project.skills?.map((skill) => renderBadge(skill.name, 'skill'))}
                        {project.industries?.map((industry) => renderBadge(industry.name, 'industry'))}
                    </div>

                </div>
            </div>

            <div className="flex flex-col divide-y pb-6">
                {!!project.links?.length && (
                    <div className="pt-4 flex flex-col gap-1 items-start">
                        <h4 className="text-sm font-medium mb-2">Links:</h4>
                        {project.links.map(link => {
                            return (
                                <a key={link} href={link} target="_blank"
                                    className="inline-block text-xs hover:underline text-primary hover:font-medium line-clamp-1 overflow-ellipsis">
                                    {link}
                                </a>
                            )
                        })}
                    </div>
                )}


                {!!project.partnerable_programs?.length && (
                    <div className="pt-6">
                        <h4 className="text-sm font-medium mb-2">Partner Programs</h4>

                        <div className="inline-grid grid-cols-[auto_auto] gap-x-4 gap-y-2 pt-1 items-center">
                            {project.partnerable_programs.map(pp => {
                                return (
                                    <Fragment key={pp.id}>
                                        <p className="text-xs">{pp.name}</p>

                                        <div>
                                            <Tag color={TAG_COLOR_MAP[pp.title]}>{pp.title}</Tag>
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                    </div>
                )}


                {!!getPDFAssets(project).length && (
                    <div className="pt-6">
                        {/* PDF Assets */}
                        <h4 className="text-sm font-medium mb-2">Documents:</h4>
                        <div className="flex flex-col flex-wrap gap-2">
                            {getPDFAssets(project).map((asset, ind) => (
                                <a
                                    key={asset.name}
                                    href={asset.path}
                                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800 line-clamp-1 overflow-ellipsis"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FileTextOutlined />
                                    {asset.name || `Document ${ind + 1} (${asset.content_type})`}
                                </a>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}


export default ProfileKeyClientRow;